
export const customersNav = [
    {url: '/customers', label: 'Customers', key: 'customers.index', permissions: []},
]